export const GrayscaleMapConfig = [
    {
        elementType: "labels.text.fill",
        featureType: "all",
        stylers: [
            {
                saturation: 36
            },
            {
                color: "#111419"
            },
            {
                lightness: 40
            }
        ]
    },
    {
        elementType: "labels.text.stroke",
        featureType: "all",
        stylers: [
            {
                visibility: "on"
            },
            {
                color: "#ffffff"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        elementType: "labels.icon",
        featureType: "all",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        elementType: "geometry.fill",
        featureType: "administrative",
        stylers: [
            {
                color: "#f9fbff"
            },
            {
                lightness: 20
            }
        ]
    },
    {
        elementType: "geometry.stroke",
        featureType: "administrative",
        stylers: [
            {
                color: "#f9fbff"
            },
            {
                lightness: 17
            },
            {
                weight: 1.2
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "landscape",
        stylers: [
            {
                color: "#ecf0f4"
            },
            {
                lightness: 20
            }
        ]
    },
    {
        elementType: "all",
        featureType: "landscape.man_made",
        stylers: [
            {
                visibility: "simplified"
            },
            {
                lightness: -4
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "poi",
        stylers: [
            {
                color: "#f9fbff"
            },
            {
                lightness: 21
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "poi.park",
        stylers: [
            {
                color: "#d9dfe8"
            },
            {
                lightness: 21
            }
        ]
    },
    {
        elementType: "geometry.fill",
        featureType: "road.highway",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 17
            }
        ]
    },
    {
        elementType: "geometry.stroke",
        featureType: "road.highway",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 29
            },
            {
                weight: 0.2
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "road.arterial",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 18
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "road.local",
        stylers: [
            {
                color: "#ffffff"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "transit",
        stylers: [
            {
                color: "#f9fbff"
            },
            {
                lightness: 19
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "water",
        stylers: [
            {
                color: "#e5eaf0"
            },
            {
                lightness: 17
            }
        ]
    }
];
//# sourceMappingURL=GrayscaleMapConfig.js.map